// Shared formatters for PerformanceSummary cells.
// Currency rendering routes through the shared utils so JPY/CAD render with
// the correct symbol, locale grouping, and minor-unit count without each
// caller special-casing it.

import { formatCurrency, formatCurrencyRounded } from '../../utils/currency';

export function fmtVal(value, fmt, currency) {
  if (value == null || Number.isNaN(value)) return '—';
  switch (fmt) {
    case 'currency':        return formatCurrency(value, currency);
    case 'currencyRounded': return formatCurrencyRounded(value, currency);
    case 'percent':         return `${Number(value).toFixed(1)}%`;
    case 'pts':             return `${Number(value).toFixed(1)} pts`;
    case 'number':          return Number(value).toFixed(2);
    case 'integer':         return Math.round(Number(value)).toLocaleString();
    case 'text':
    default:                return String(value);
  }
}

// Formats a delta value with the given fmt. The arrow conveys sign; the
// returned string is unsigned so it pairs cleanly with the arrow glyph.
export function fmtDelta(value, fmt, currency) {
  if (value == null || Number.isNaN(value) || value === 0) return null;
  const abs = Math.abs(value);
  switch (fmt) {
    case 'currency':        return formatCurrency(abs, currency);
    case 'currencyRounded': return formatCurrencyRounded(abs, currency);
    case 'percent':         return `${abs.toFixed(1)} pts`;
    case 'pts':             return `${abs.toFixed(1)} pts`;
    case 'number':          return abs.toFixed(2);
    case 'integer':         return Math.round(abs).toLocaleString();
    case 'text':
    default:                return String(abs);
  }
}

export function fmtPctDelta(pct) {
  if (pct == null || Number.isNaN(pct)) return null;
  return `${Math.abs(pct).toFixed(1)}%`;
}

export function pctChange(delta, value) {
  if (delta == null || value == null || value === 0) return null;
  return (delta / value) * 100;
}

// Cell tone given (delta, inverted). Returns 'pos' | 'neg' | 'warn' | 'neu'.
// inverted = true for cost-like metrics (labor%, OT%, wages, HPOR, expenses)
// where a *negative* delta is favorable.
export function toneForDelta(delta, { inverted = false, neutralThreshold = 0 } = {}) {
  if (delta == null || Math.abs(delta) <= neutralThreshold) return 'neu';
  if (inverted) return delta < 0 ? 'pos' : 'warn';
  return delta > 0 ? 'pos' : 'neg';
}
